module.exports = __webpack_public_path__ + "static/media/product_32_blue.218e2c03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/product_32_blue.svg
// module id = 354
// module chunks = 0